export const getReplyValue = reply => {
  if (!reply) {
    return ''
  }
  if (reply.question.type.name === 'sign') {
    return reply.value.name
  }
  return reply.value
}

export const findReplyByQuestionId = (replies, questionId) => {
  return replies.find(reply => reply.question.id === questionId)
}

export const findReplyByFieldId = (replies, fieldId) => {
  return replies.find(reply => reply.field.id === fieldId)
}

export const filterReplyByQuestionId = (replies, questionId) => {
  return replies.filter(reply => reply.question.id === questionId)
}

export const getFieldValue = (fieldValues, fieldName) => {
  return fieldValues.find(fv => {
    return fv.field.name === fieldName
  })
}

export const getOSByTemplateId = templateId => {
  if (templateId === 3) {
    return {
      role: 'MOTORISTA DE CAMINHÃO TRUCK',
      description:
        'Transporta materiais e produtos para diversos itinerários. Elabora relatórios de viagem e rota. Efetua a prestação de contas das despesas efetuadas com o veículo. Zela pela conservação e segurança dos veículos, providenciando limpeza, ajustes e pequenos reparos',
      physicalRisks: 'Ruido Vibração Localizada (Mão e Braço)',
      chemicalRisks: 'Poeira',
      ergonomicRisks: 'Postura sentada por longos período',
      accidentsRisks: 'Acidente de Trânsito / Atropelamento'
    }
  }

  if (templateId === 4) {
    return {
      role: 'AUXILIAR DE SERVIÇOS GERAIS',
      description:
        'Responsável pela poda e corte de árvores com uma motosserra ou roçadeira. Ele é um profissional e geralmente trabalha no manejo florestal.',
      physicalRisks: 'Ruido',
      chemicalRisks: 'Poeira',
      ergonomicRisks: 'Postura incorretas / Arranjo físico inadequado',
      accidentsRisks: 'Queda de mesmo nível / Queda de nível diferente objetos e/ou materiais'
    }
  }

  if (templateId === 5) {
    return {
      role: 'OPERADOR DE MOTOSSERRA',
      description:
        'Responsável pela poda e corte de árvores com uma motosserra ou roçadeira. Ele é um profissional e geralmente trabalha no manejo florestal.',
      physicalRisks: 'Ruido Vibração Localizada (Mão e Braço)',
      chemicalRisks: 'Poeira',
      ergonomicRisks: 'Postura sentada por longos período',
      accidentsRisks: 'Acidente de Trânsito / Atropelamento'
    }
  }
}

export const getCourseByTemplateId = templateId => {
  if (templateId === 6) {
    return {
      name: 'Condições e meio de ambiente de trabalho na indústria da construção - NR-18',
      content: [
        '1. Apresentação da norma NR-18;',
        '2. CIPA;',
        '3. Condições de Meio Ambiente e Segurança;',
        '4. Riscos físicos, químicos, biológicos, ergonômicos e risco de acidentes;',
        '5. EPI – Equipamentos de Proteção Individual;',
        '6. EPC – Equipamentos de Proteção Coletiva;',
        '7. Combate a incêndios;',
        '8. Primeiros socorros;',
        '9. Proteção em maquinas e equipamentos;',
        '10. Movimentação de matérias e transporte de matérias e pessoas;',
        '11. Vestiário;',
        '12. Higiene;',
        '13. Conforto;',
        '14. Andaimes;',
        '15. Instalações elétricas;',
        '16. Sinalização de Segurança.'
      ]
    }
  }
  if (templateId === 7) {
    return {
      name: 'Trabalho em altura – NR-35',
      content: [
        '1. Normas e regulamentos aplicáveis ao trabalho em altura;',
        '2. Analise de risco e condições impeditivas;',
        '3. Sistemas / Equipamentos / Procedimentos de proteção;',
        '4. Acidentes típicos de trabalho em altura;',
        '5. Condutas em situações de emergência.'
      ]
    }
  }
  if (templateId === 8) {
    return {
      name: 'Segurança no trabalho em Motosserras - NR-12',
      content: [
        '1. Apresentação da Norma NR-12;',
        '2. Cenário Brasileiro de Acidentes de Trabalho;',
        '3. Estrutura da NR 12;',
        '4. Pontos da NR 12;',
        '5. Anexo V – Motosserras;',
        '6. Riscos a serem avaliados para Operados de Motosserras;',
        '7. Avaliação dos acidentes com Operadores de Motosserras;',
        '8. Equipamentos de Proteção individual para Operadores de Motosserras;',
        '9. Dispositivos de Segurança da Motosserra;',
        '10. Procedimento para realização de corte com segurança;',
        '11. Principais recomendações de segurança de corte no uso de motosserras.'
      ]
    }
  }
  if (templateId === 9) {
    return {
      name: 'Segurança no trabalho em maquinas e equipamentos - NR-12',
      content: [
        '1. Normas Regulamentadoras;',
        '2. Norma Regulamentadora 12 - Apresentação;',
        '3. Estrutura da NR-12;',
        '4. Gestão dos Riscos em Máquinas e Equipamentos;',
        '5. Arranjo Físico e Instalações;',
        '6. Sinalização;',
        '7. Medidas de Proteção de Máquinas;',
        '8. Riscos nos Postos de Trabalho;',
        '9. Arranjo Físico e Instalações no Ambiente do Trabalho;',
        '10. Avaliação das Medidas do seu Ambiente de Trabalho;',
        '11. Condições do Ambiente para a Instalação de Máquinas Estacionárias;',
        '12. Aspectos Ergonômicos;',
        '13. Procedimento em Relação a Máquinas Antigas;',
        '14. Riscos Adicionais;',
        '15. Fiscalização;',
        '16. Equipamento de Proteção Individual – EPI;',
        '17. Equipamento de Proteção Coletiva - EPC;',
        '18. Vestuário;',
        '19. Primeiros Socorros.'
      ]
    }
  }
  if (templateId === 10) {
    return {
      name: 'Ergonomia – NR-17',
      content: [
        '1. Apresentação da norma NR-17;',
        '2. Introdução à Ergonomia;',
        '3. Categoria da Ergonomia;',
        '4. Fatores de Riscos no Trabalho;',
        '5. Ferramentas da Ergonomia;',
        '6. Características e boas praticas ergonômicas no ambiente de trabalho;',
        '7. Lesão por esforço repetitivo;',
        '8. Equação do Niosch para o levantamento manual de cargas.'
      ]
    }
  }
}
